module.exports = __webpack_public_path__ + "static/media/broken-shield.338c0c13.png";